import { tKey } from 'ember-intl';
// requestConfigData
export const CONFIG_DATA = {
  short_term_rental_config: {
    id: 'test',
    radius_limit: 50,
    price_range_limit_min: 20,
    price_range_limit_max: 13631,
  },
};

// requestKpis
export const OCCUPANCY_OWN_HOTEL_KPIS = {
  short_term_rental_kpis: [
    {
      id: 'occupancy.ownhotel',
      type: 'occupancy',
      subtype: 'ownhotel',
      message: '',
      value: '0.5693',
      difference: '0',
    },
  ],
};

export const RENTAL_KPIS = {
  short_term_rental_kpis: [
    {
      id: 'occupancy.shorttermrental',
      type: 'occupancy',
      subtype: 'shorttermrental',
      message: '',
      value: 0.59,
      difference: 0.05,
    },
    {
      id: 'rate.shorttermrental',
      type: 'rate',
      subtype: 'shorttermrental',
      message: '',
      value: 481,
      difference: 2,
    },
  ],
};

export const PROPERTIES_KPIS = {
  short_term_rental_kpis: [
    {
      id: 'listings.relevant',
      type: 'listings',
      subtype: 'relevant',
      message: '',
      value: 164,
      difference: null,
    },
    {
      id: 'listings.total',
      type: 'listings',
      subtype: 'total',
      message: '',
      value: 18053,
      difference: null,
    },
    {
      id: 'beds.relevant',
      type: 'beds',
      subtype: 'relevant',
      message: '',
      value: 267,
      difference: null,
    },
    {
      id: 'beds.total',
      type: 'beds',
      subtype: 'total',
      message: '',
      value: 35341,
      difference: null,
    },
  ],
};

export const RATES_KPIS = {
  short_term_rental_kpis: [
    {
      id: 'rate.ownhotel',
      type: 'rate',
      subtype: 'ownhotel',
      message: '',
      value: 550,
      difference: 0,
    },
  ],
};

// requestBreakdowns
export const BREAKDOWNS = {
  meta: {
    message: '',
  },
  short_term_rental_breakdowns: [
    {
      id: 'type.entire_home',
      type: 'type',
      sub_type: 'entire_home',
      value: 1.0,
    },
    {
      id: 'type.private_room',
      type: 'type',
      sub_type: 'private_room',
      value: 0,
    },
    {
      id: 'type.shared_room',
      type: 'type',
      sub_type: 'shared_room',
      value: 0,
    },
    {
      id: 'subtype.apartment',
      type: 'subtype',
      sub_type: 'apartment',
      value: 0.85,
    },
    {
      id: 'subtype.house',
      type: 'subtype',
      sub_type: 'house',
      value: 0,
    },
    {
      id: 'subtype.townhouse',
      type: 'subtype',
      sub_type: 'townhouse',
      value: 0.01,
    },
    {
      id: 'subtype.other',
      type: 'subtype',
      sub_type: 'other',
      value: 0,
    },
    {
      id: 'subtype.glamping',
      type: 'subtype',
      sub_type: 'glamping',
      value: 0,
    },
    {
      id: 'subtype.bed_&breakfast',
      type: 'subtype',
      sub_type: 'bed&_breakfast',
      value: 0,
    },
    {
      id: 'subtype.villa',
      type: 'subtype',
      sub_type: 'villa',
      value: 0,
    },
    {
      id: 'subtype.chalet',
      type: 'subtype',
      sub_type: 'chalet',
      value: 0,
    },
    {
      id: 'subtype.hotel',
      type: 'subtype',
      sub_type: 'hotel',
      value: 0.12,
    },
    {
      id: 'subtype.guest_house',
      type: 'subtype',
      sub_type: 'guest_house',
      value: 0,
    },
    {
      id: 'subtype.bungalow',
      type: 'subtype',
      sub_type: 'bungalow',
      value: 0,
    },
    {
      id: 'subtype.rv',
      type: 'subtype',
      sub_type: 'rv',
      value: 0,
    },
    {
      id: 'subtype.hostel',
      type: 'subtype',
      sub_type: 'hostel',
      value: 0,
    },
    {
      id: 'subtype.boat',
      type: 'subtype',
      sub_type: 'boat',
      value: 0,
    },
    {
      id: 'subtype.aparthotel',
      type: 'subtype',
      sub_type: 'aparthotel',
      value: 0.03,
    },
    {
      id: 'subtype.castle',
      type: 'subtype',
      sub_type: 'castle',
      value: 0,
    },
    {
      id: 'subtype.dorm',
      type: 'subtype',
      sub_type: 'dorm',
      value: 0,
    },
    {
      id: 'review_score.3;5-',
      type: 'review_score',
      sub_type: '3;5-',
      value: 0,
    },
    {
      id: 'review_score.4-',
      type: 'review_score',
      sub_type: '4-',
      value: 0.01,
    },
    {
      id: 'review_score.4;5-',
      type: 'review_score',
      sub_type: '4;5-',
      value: 0.05,
    },
    {
      id: 'review_score.5-',
      type: 'review_score',
      sub_type: '5-',
      value: 0.23,
    },
    {
      id: 'review_score.5',
      type: 'review_score',
      sub_type: '5',
      value: 0.71,
    },
    {
      id: 'capacity.2',
      type: 'capacity',
      sub_type: '2',
      value: 0.34,
    },
    {
      id: 'capacity.4',
      type: 'capacity',
      sub_type: '4',
      value: 0.66,
    },
    {
      id: 'capacity.6',
      type: 'capacity',
      sub_type: '6',
      value: 0,
    },
    {
      id: 'capacity.8',
      type: 'capacity',
      sub_type: '8',
      value: 0,
    },
    {
      id: 'capacity.+',
      type: 'capacity',
      sub_type: '+',
      value: 0,
    },
    {
      id: 'min_stay.1',
      type: 'min_stay',
      sub_type: '1',
      value: 0.42,
    },
    {
      id: 'min_stay.2',
      type: 'min_stay',
      sub_type: '2',
      value: 0.3,
    },
    {
      id: 'min_stay.3',
      type: 'min_stay',
      sub_type: '3',
      value: 0.27,
    },
    {
      id: 'min_stay.4',
      type: 'min_stay',
      sub_type: '4',
      value: 0,
    },
    {
      id: 'min_stay.5_7',
      type: 'min_stay',
      sub_type: '5_7',
      value: 0,
    },
    {
      id: 'min_stay.8_14',
      type: 'min_stay',
      sub_type: '8_14',
      value: 0,
    },
    {
      id: 'min_stay.15_31',
      type: 'min_stay',
      sub_type: '15_31',
      value: 0,
    },
    {
      id: 'additional_fees.0_90',
      type: 'additional_fees',
      sub_type: '0_90',
      value: 0.24,
    },
    {
      id: 'additional_fees.90_200',
      type: 'additional_fees',
      sub_type: '90_200',
      value: 0.13,
    },
    {
      id: 'additional_fees.200_400',
      type: 'additional_fees',
      sub_type: '200_400',
      value: 0.38,
    },
    {
      id: 'additional_fees.400_600',
      type: 'additional_fees',
      sub_type: '400_600',
      value: 0.16,
    },
    {
      id: 'additional_fees.600_15000',
      type: 'additional_fees',
      sub_type: '600_15000',
      value: 0.08,
    },
    {
      id: 'amenity.twenty_four_hour_checkin',
      type: 'amenity',
      sub_type: 'twenty_four_hour_checkin',
      value: 0.11,
    },
    {
      id: 'amenity.air_conditioning',
      type: 'amenity',
      sub_type: 'air_conditioning',
      value: 0.85,
    },
    {
      id: 'amenity.bikes_available',
      type: 'amenity',
      sub_type: 'bikes_available',
      value: 0.32,
    },
    {
      id: 'amenity.breakfast',
      type: 'amenity',
      sub_type: 'breakfast',
      value: 0.13,
    },
    {
      id: 'amenity.buzzer_or_wireless_intercom',
      type: 'amenity',
      sub_type: 'buzzer_or_wireless_intercom',
      value: 0.37,
    },
    {
      id: 'amenity.carbon_monoxide_detector',
      type: 'amenity',
      sub_type: 'carbon_monoxide_detector',
      value: 0.87,
    },
    {
      id: 'amenity.dishwasher',
      type: 'amenity',
      sub_type: 'dishwasher',
      value: 0.19,
    },
    {
      id: 'amenity.doorman',
      type: 'amenity',
      sub_type: 'doorman',
      value: 0.33,
    },
    {
      id: 'amenity.dryer',
      type: 'amenity',
      sub_type: 'dryer',
      value: 0.43,
    },
    {
      id: 'amenity.essentials',
      type: 'amenity',
      sub_type: 'essentials',
      value: 0.46,
    },
    {
      id: 'amenity.fireplace',
      type: 'amenity',
      sub_type: 'fireplace',
      value: 0.37,
    },
    {
      id: 'amenity.fire_extinguisher',
      type: 'amenity',
      sub_type: 'fire_extinguisher',
      value: 0.69,
    },
    {
      id: 'amenity.first_aid_kit',
      type: 'amenity',
      sub_type: 'first_aid_kit',
      value: 0.63,
    },
    {
      id: 'amenity.garden',
      type: 'amenity',
      sub_type: 'garden',
      value: 0.51,
    },
    {
      id: 'amenity.gym',
      type: 'amenity',
      sub_type: 'gym',
      value: 0.17,
    },
    {
      id: 'amenity.hair_dryer',
      type: 'amenity',
      sub_type: 'hair_dryer',
      value: 0.83,
    },
    {
      id: 'amenity.hangers',
      type: 'amenity',
      sub_type: 'hangers',
      value: 0.82,
    },
    {
      id: 'amenity.heating',
      type: 'amenity',
      sub_type: 'heating',
      value: 0.45,
    },
    {
      id: 'amenity.hot_tub',
      type: 'amenity',
      sub_type: 'hot_tub',
      value: 0.41,
    },
    {
      id: 'amenity.internet',
      type: 'amenity',
      sub_type: 'internet',
      value: 0.49,
    },
    {
      id: 'amenity.iron',
      type: 'amenity',
      sub_type: 'iron',
      value: 0.41,
    },
    {
      id: 'amenity.kid_friendly',
      type: 'amenity',
      sub_type: 'kid_friendly',
      value: 0.35,
    },
    {
      id: 'amenity.kitchen',
      type: 'amenity',
      sub_type: 'kitchen',
      value: 0.35,
    },
    {
      id: 'amenity.laptop_friendly_workspace',
      type: 'amenity',
      sub_type: 'laptop_friendly_workspace',
      value: 0.02,
    },
    {
      id: 'amenity.lock_on_bedroom_door',
      type: 'amenity',
      sub_type: 'lock_on_bedroom_door',
      value: 0.12,
    },
    {
      id: 'amenity.microwave',
      type: 'amenity',
      sub_type: 'microwave',
      value: 0.24,
    },
    {
      id: 'amenity.non_smoking_only',
      type: 'amenity',
      sub_type: 'non_smoking_only',
      value: 0.01,
    },
    {
      id: 'amenity.no_essentials',
      type: 'amenity',
      sub_type: 'no_essentials',
      value: 0.06,
    },
    {
      id: 'amenity.no_internet',
      type: 'amenity',
      sub_type: 'no_internet',
      value: 0.09,
    },
    {
      id: 'amenity.no_parking',
      type: 'amenity',
      sub_type: 'no_parking',
      value: 0.26,
    },
    {
      id: 'amenity.no_pets_allowed',
      type: 'amenity',
      sub_type: 'no_pets_allowed',
      value: 0.16,
    },
    {
      id: 'amenity.no_wheelchair_accessible',
      type: 'amenity',
      sub_type: 'no_wheelchair_accessible',
      value: 0.03,
    },
    {
      id: 'amenity.outdoor_grill',
      type: 'amenity',
      sub_type: 'outdoor_grill',
      value: 0.26,
    },
    {
      id: 'amenity.oven',
      type: 'amenity',
      sub_type: 'oven',
      value: 0.26,
    },
    {
      id: 'amenity.parking',
      type: 'amenity',
      sub_type: 'parking',
      value: 0.45,
    },
    {
      id: 'amenity.patio_or_balcony',
      type: 'amenity',
      sub_type: 'patio_or_balcony',
      value: 0.02,
    },
    {
      id: 'amenity.pets_allowed',
      type: 'amenity',
      sub_type: 'pets_allowed',
      value: 0.22,
    },
    {
      id: 'amenity.pool',
      type: 'amenity',
      sub_type: 'pool',
      value: 0.15,
    },
    {
      id: 'amenity.refrigerator',
      type: 'amenity',
      sub_type: 'refrigerator',
      value: 0.74,
    },
    {
      id: 'amenity.restaurant',
      type: 'amenity',
      sub_type: 'restaurant',
      value: 0.43,
    },
    {
      id: 'amenity.safety_card',
      type: 'amenity',
      sub_type: 'safety_card',
      value: 0.02,
    },
    {
      id: 'amenity.sauna',
      type: 'amenity',
      sub_type: 'sauna',
      value: 0.05,
    },
    {
      id: 'amenity.shampoo',
      type: 'amenity',
      sub_type: 'shampoo',
      value: 0.39,
    },
    {
      id: 'amenity.smoke_detector',
      type: 'amenity',
      sub_type: 'smoke_detector',
      value: 0.41,
    },
    {
      id: 'amenity.spa_and_wellness_centre',
      type: 'amenity',
      sub_type: 'spa_and_wellness_centre',
      value: 0.06,
    },
    {
      id: 'amenity.spa_bath',
      type: 'amenity',
      sub_type: 'spa_bath',
      value: 0.02,
    },
    {
      id: 'amenity.stove_or_oven',
      type: 'amenity',
      sub_type: 'stove_or_oven',
      value: 0.48,
    },
    {
      id: 'amenity.suitable_for_events',
      type: 'amenity',
      sub_type: 'suitable_for_events',
      value: 0.02,
    },
    {
      id: 'amenity.tennis_court',
      type: 'amenity',
      sub_type: 'tennis_court',
      value: 0.33,
    },
    {
      id: 'amenity.terrace',
      type: 'amenity',
      sub_type: 'terrace',
      value: 0.05,
    },
    {
      id: 'amenity.tv',
      type: 'amenity',
      sub_type: 'tv',
      value: 0.52,
    },
    {
      id: 'amenity.view',
      type: 'amenity',
      sub_type: 'view',
      value: 0.13,
    },
    {
      id: 'amenity.washing_machine',
      type: 'amenity',
      sub_type: 'washing_machine',
      value: 0.21,
    },
    {
      id: 'amenity.wheelchair_accessible',
      type: 'amenity',
      sub_type: 'wheelchair_accessible',
      value: 0.59,
    },
    {
      id: 'pricing_type.dynamic',
      type: 'pricing_type',
      sub_type: 'dynamic',
      value: 0.52,
    },
    {
      id: 'pricing_type.static',
      type: 'pricing_type',
      sub_type: 'static',
      value: 0.48,
    },
  ],
};

// requestEvolutionChartData
export const RATES_PARAMS_RANGE = {
  days: [
    {
      id: '2023-07-18',
      date: '2023-07-18',
      integer_date: 19556,
    },
    {
      id: '2023-07-19',
      date: '2023-07-19',
      integer_date: 19557,
    },
    {
      id: '2023-07-20',
      date: '2023-07-20',
      integer_date: 19558,
    },
  ],
  periods: [
    {
      from_date: '2023-07-18',
      id: '2023-07-18,,1,test',
      los: 1,
      leadtime: -1,
      day: '2023-07-18',
      rates: {
        1: [
          {
            value: 0,
            cancellation: false,
            id: 'ciqkecc28l9s73e8b07g',
            city_tax: 0,
            city_tax_incl: false,
            shop_city_tax_incl: false,
            is_baserate: false,
            other_taxes_incl: false,
            shop_other_taxes_incl: false,
            vat_incl: false,
            shop_vat_incl: false,
            is_wholesale_rate: false,
            is_out_of_sync: false,
            best_flex: false,
            cancellable: false,
            currency: '',
            shop_currency: '',
            difference_with_baserate: 0,
            extract_datetime: '2023-07-17T05:35:22Z',
            hotelinfo: 357419,
            max_persons: 0,
            mealtype_included: 0,
            membershiptype: 0,
            message: 'rates.soldout',
            ota: 'bookingdotcom',
            other_taxes: 0,
            period: '2023-07-18,,1,',
            position_to_baserate: 0,
            shop_value: 0,
            room_name: '',
            room_type: '',
            vat: 0,
            comparison_rates: [
              {
                cancellation: false,
                id: '50c432b6-fe79-4071-b938-6aa6c881cd36',
                extract_datetime: '2023-07-16T05:25:44Z',
                best_flex: false,
                cancellable: false,
                currency: '',
                value: 0,
                message: 'rates.soldout',
                room_name: '',
                membershiptype: 0,
                mealtype_included: 0,
                labels: null,
                from_date: '2023-07-18',
                compare_set_id: 1,
                difference_absolute: 0,
                difference_relative: 0,
                compare_messages: null,
                outlier_score: 0,
              },
            ],
            labels: null,
            rate_code: '',
            rate_name: '',
            pos: '',
            issue_type: 0,
            platform: 0,
          },
        ],
      },
    },
    {
      from_date: '2023-07-19',
      id: '2023-07-19,,1,test',
      los: 1,
      leadtime: -1,
      day: '2023-07-19',
      rates: {
        1: [
          {
            value: 0,
            cancellation: false,
            id: 'ciqkecc28l9s73e8b06g',
            city_tax: 0,
            city_tax_incl: false,
            shop_city_tax_incl: false,
            is_baserate: false,
            other_taxes_incl: false,
            shop_other_taxes_incl: false,
            vat_incl: false,
            shop_vat_incl: false,
            is_wholesale_rate: false,
            is_out_of_sync: false,
            best_flex: false,
            cancellable: false,
            currency: '',
            shop_currency: '',
            difference_with_baserate: 0,
            extract_datetime: '2023-07-17T04:33:04Z',
            hotelinfo: 357419,
            max_persons: 0,
            mealtype_included: 0,
            membershiptype: 0,
            message: tKey('rates.restrictionlos2'),
            ota: 'bookingdotcom',
            other_taxes: 0,
            period: '2023-07-19,,1,',
            position_to_baserate: 0,
            shop_value: 0,
            room_name: '',
            room_type: '',
            vat: 0,
            comparison_rates: [
              {
                cancellation: false,
                id: '29cb0f3c-ec11-47a4-a612-1c34489906a4',
                extract_datetime: '2023-07-16T04:21:49Z',
                best_flex: false,
                cancellable: false,
                currency: '',
                value: 0,
                message: tKey('rates.restrictionlos2'),
                room_name: '',
                membershiptype: 0,
                mealtype_included: 0,
                labels: null,
                from_date: '2023-07-19',
                compare_set_id: 1,
                difference_absolute: 0,
                difference_relative: 0,
                compare_messages: null,
                outlier_score: 0,
              },
            ],
            labels: null,
            rate_code: '',
            rate_name: '',
            pos: '',
            issue_type: 0,
            platform: 0,
          },
        ],
      },
    },
    {
      from_date: '2023-07-20',
      id: '2023-07-20,,1,test',
      los: 1,
      leadtime: -1,
      day: '2023-07-20',
      rates: {
        1: [
          {
            value: 550,
            cancellation: true,
            id: 'ciqkecc28l9s73e8b08g',
            city_tax: 3.5,
            city_tax_incl: false,
            shop_city_tax_incl: false,
            is_baserate: false,
            other_taxes_incl: false,
            shop_other_taxes_incl: false,
            vat_incl: false,
            shop_vat_incl: false,
            is_wholesale_rate: false,
            is_out_of_sync: false,
            best_flex: true,
            cancellable: true,
            currency: 'USD',
            shop_currency: 'USD',
            difference_with_baserate: 0,
            extract_datetime: '2023-07-17T05:40:25Z',
            hotelinfo: 357419,
            max_persons: 4,
            mealtype_included: 0,
            membershiptype: 0,
            message: '',
            ota: 'bookingdotcom',
            other_taxes: 0,
            period: '2023-07-20,,1,',
            position_to_baserate: 0,
            shop_value: 550,
            room_name: 'Superior Room with Two Double Beds',
            room_type: 'standard',
            vat: 81.125,
            comparison_rates: [
              {
                cancellation: true,
                id: 'c72ef519-a9e5-4327-ac79-8f61550135d9',
                extract_datetime: '2023-07-16T04:19:05Z',
                best_flex: true,
                cancellable: true,
                currency: 'USD',
                value: 550,
                message: '',
                room_name: 'Superior Room with Two Double Beds',
                membershiptype: 0,
                mealtype_included: 0,
                labels: [],
                from_date: '2023-07-20',
                compare_set_id: 1,
                difference_absolute: 0,
                difference_relative: 0,
                compare_messages: [],
                outlier_score: 0,
              },
            ],
            labels: [],
            rate_code: '',
            rate_name: '',
            pos: '',
            issue_type: 0,
            platform: 0,
          },
        ],
      },
    },
  ],
  meta: {},
};

export const OCCUPANCY_PARAMS_RANGE = {
  days: [
    {
      id: '2023-07-18',
      date: '2023-07-18',
      integer_date: 19556,
    },
    {
      id: '2023-07-19',
      date: '2023-07-19',
      integer_date: 19557,
    },
    {
      id: '2023-07-20',
      date: '2023-07-20',
      integer_date: 19558,
    },
  ],
  occupancies: [
    {
      hotelinfo: 357419,
      day: '2023-07-18',
      extract_date: '2023-07-26',
      benchmark_extract_date: '2023-07-20',
      occupancy_changes: [
        {
          occupancy: '357419,2023-07-18',
          extract_date: '2023-08-02',
          id: '357419,2023-07-18,2023-08-02',
          rooms_booked_individual: -10000,
          rooms_booked_group: -10000,
          rooms_booked: -10000,
          rooms_out_of_order: -10000,
          total_capacity: -10000,
          message: 'general.missing',
          benchmark_value: 0,
          benchmark_message: 'general.missing',
        },
      ],
      date_aggregation: 'day',
      id: '357419,2023-07-18,test',
      rooms_booked_individual: 390,
      rooms_booked_group: 520,
      rooms_booked: 910,
      rooms_out_of_order: 0,
      total_capacity: 909,
      benchmark_value: 0.9777794207368239,
    },
    {
      hotelinfo: 357419,
      day: '2023-07-19',
      extract_date: '2023-07-27',
      benchmark_extract_date: '2023-07-21',
      occupancy_changes: [
        {
          occupancy: '357419,2023-07-19',
          extract_date: '2023-08-02',
          id: '357419,2023-07-19,2023-08-02',
          rooms_booked_individual: -10000,
          rooms_booked_group: -10000,
          rooms_booked: -10000,
          rooms_out_of_order: -10000,
          total_capacity: -10000,
          message: 'general.missing',
          benchmark_value: 0,
          benchmark_message: 'general.missing',
        },
      ],
      date_aggregation: 'day',
      id: '357419,2023-07-19,test',
      rooms_booked_individual: 415,
      rooms_booked_group: 474,
      rooms_booked: 889,
      rooms_out_of_order: 11,
      total_capacity: 909,
      benchmark_value: 0.9612863753524764,
    },
    {
      hotelinfo: 357419,
      day: '2023-07-20',
      extract_date: '2023-07-28',
      benchmark_extract_date: '2023-07-22',
      occupancy_changes: [
        {
          occupancy: '357419,2023-07-20',
          extract_date: '2023-08-02',
          id: '357419,2023-07-20,2023-08-02',
          rooms_booked_individual: -10000,
          rooms_booked_group: -10000,
          rooms_booked: -10000,
          rooms_out_of_order: -10000,
          total_capacity: -10000,
          message: 'general.missing',
          benchmark_value: 0,
          benchmark_message: 'general.missing',
        },
      ],
      date_aggregation: 'day',
      id: '357419,2023-07-20,test',
      rooms_booked_individual: 465,
      rooms_booked_group: 200,
      rooms_booked: 665,
      rooms_out_of_order: 64,
      total_capacity: 909,
      benchmark_value: 0.9121275327711288,
    },
  ],
};

export const SHORT_TERM_RENTAL_PARAMS_RANGE = {
  short_term_rental_occupancies: [
    {
      id: '2023-07-18,1970-01-01',
      day: '2023-07-18',
      extract_date: '2023-07-17',
      message: '',
      value: 0.62,
      compare_short_term_rental_occupancies: [
        {
          id: '2023-07-18,2023-07-16',
          day: '2023-07-18',
          extract_date: '2023-07-16',
          message: '',
          value: 0.56,
        },
      ],
    },
    {
      id: '2023-07-19,1970-01-01',
      day: '2023-07-19',
      extract_date: '2023-07-17',
      message: '',
      value: 0.59,
      compare_short_term_rental_occupancies: [
        {
          id: '2023-07-19,2023-07-16',
          day: '2023-07-19',
          extract_date: '2023-07-16',
          message: '',
          value: 0.55,
        },
      ],
    },
    {
      id: '2023-07-20,1970-01-01',
      day: '2023-07-20',
      extract_date: '2023-07-17',
      message: '',
      value: 0.56,
      compare_short_term_rental_occupancies: [
        {
          id: '2023-07-20,2023-07-16',
          day: '2023-07-20',
          extract_date: '2023-07-16',
          message: '',
          value: 0.49,
        },
      ],
    },
  ],
  short_term_rental_rates: [
    {
      id: '2023-07-18,1970-01-01',
      day: '2023-07-18',
      extract_date: '2023-07-17',
      message: '',
      value: 481,
      currency: 'USD',
      compare_short_term_rental_rates: [
        {
          id: '2023-07-18,2023-07-16',
          day: '2023-07-18',
          extract_date: '2023-07-16',
          message: '',
          value: 480,
          currency: 'USD',
        },
      ],
    },
    {
      id: '2023-07-19,1970-01-01',
      day: '2023-07-19',
      extract_date: '2023-07-17',
      message: '',
      value: 487,
      currency: 'USD',
      compare_short_term_rental_rates: [
        {
          id: '2023-07-19,2023-07-16',
          day: '2023-07-19',
          extract_date: '2023-07-16',
          message: '',
          value: 484,
          currency: 'USD',
        },
      ],
    },
    {
      id: '2023-07-20,1970-01-01',
      day: '2023-07-20',
      extract_date: '2023-07-17',
      message: '',
      value: 476,
      currency: 'USD',
      compare_short_term_rental_rates: [
        {
          id: '2023-07-20,2023-07-16',
          day: '2023-07-20',
          extract_date: '2023-07-16',
          message: '',
          value: 474,
          currency: 'USD',
        },
      ],
    },
  ],
  meta: {
    relevant_properties: 164,
  },
};

export const EVENTS = {
  days: [
    {
      id: '2023-07-14',
      date: '2023-07-14',
      integer_date: 19552,
    },
    {
      id: '2023-07-15',
      date: '2023-07-15',
      integer_date: 19553,
    },
    {
      id: '2023-07-16',
      date: '2023-07-16',
      integer_date: 19554,
    },
    {
      id: '2023-07-17',
      date: '2023-07-17',
      integer_date: 19555,
    },
    {
      id: '2023-07-18',
      date: '2023-07-18',
      integer_date: 19556,
    },
    {
      id: '2023-07-19',
      date: '2023-07-19',
      integer_date: 19557,
    },
    {
      id: '2023-07-20',
      date: '2023-07-20',
      integer_date: 19558,
    },
    {
      id: '2023-07-21',
      date: '2023-07-21',
      integer_date: 19559,
    },
  ],
  events: [
    {
      name: 'Games for Change Virtual Festival',
      location: 'United Nations Headquarters',
      category: 'conference',
      importance: 2,
      start_date: '2023-07-14',
      end_date: '2023-07-21',
      description: '',
      lat: 40.7488758,
      lon: -73.9680091,
      visitors: 5000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-5060831',
      hotel: 1,
      url: '',
      created_timestamp: '2023-04-23T02:07:04.000Z',
      last_update_timestamp: '2023-07-20T16:57:26.000Z',
      status: '',
      is_new_event: false,
      periods: [
        '2023-07-14,1',
        '2023-07-15,1',
        '2023-07-16,1',
        '2023-07-17,1',
        '2023-07-18,1',
        '2023-07-19,1',
        '2023-07-20,1',
        '2023-07-21,1',
      ],
      days: [
        '2023-07-14',
        '2023-07-15',
        '2023-07-16',
        '2023-07-17',
        '2023-07-18',
        '2023-07-19',
        '2023-07-20',
        '2023-07-21',
      ],
      labels: ['expo'],
    },
    {
      name: 'PROJECT',
      location: '',
      category: 'conference',
      importance: 2,
      start_date: '2023-07-17',
      end_date: '2023-07-19',
      description: '',
      lat: 40.742229,
      lon: -73.990688,
      visitors: 50000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-4954294',
      hotel: 1,
      url: '',
      created_timestamp: '2023-04-01T19:06:39.000Z',
      last_update_timestamp: '2023-07-07T06:10:02.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-17,1', '2023-07-18,1', '2023-07-19,1'],
      days: ['2023-07-17', '2023-07-18', '2023-07-19'],
      labels: ['expo'],
    },
    {
      name: 'Fundamentals of Finance and Accounting for Non-Financial Managers',
      location: 'AMA Conference Center New York City',
      category: 'conference',
      importance: 1,
      start_date: '2023-07-17',
      end_date: '2023-07-18',
      description: '',
      lat: 40.7606967,
      lon: -73.9852333,
      visitors: 5000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-5543885',
      hotel: 1,
      url: '',
      created_timestamp: '2023-07-06T03:05:31.000Z',
      last_update_timestamp: '2023-07-19T06:06:57.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-17,1', '2023-07-18,1'],
      days: ['2023-07-17', '2023-07-18'],
      labels: ['expo'],
    },
    {
      name: 'Functional Fabric Fair Summer',
      location: '',
      category: 'conference',
      importance: 2,
      start_date: '2023-07-18',
      end_date: '2023-07-19',
      description: '',
      lat: 40.7575505,
      lon: -74.0024691,
      visitors: 2000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-3806855',
      hotel: 1,
      url: '',
      created_timestamp: '2022-07-20T23:07:08.000Z',
      last_update_timestamp: '2023-07-18T06:05:36.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-18,1', '2023-07-19,1'],
      days: ['2023-07-18', '2023-07-19'],
      labels: ['expo', 'industrial'],
    },
    {
      name: 'First Aid Kit with The Weather Station',
      location: 'Radio City Music Hall',
      category: 'music',
      importance: 2,
      start_date: '2023-07-18',
      end_date: '2023-07-18',
      description: '',
      lat: 40.75997599999999,
      lon: -73.9799772,
      visitors: 4600,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-4218605',
      hotel: 1,
      url: '',
      created_timestamp: '2022-11-05T01:07:52.000Z',
      last_update_timestamp: '2023-07-16T06:05:26.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-18,1'],
      days: ['2023-07-18'],
      labels: ['concert', 'music'],
    },
    {
      name: 'Chicago White Sox vs New York Mets',
      location: 'Citi Field',
      category: 'sport',
      importance: 1,
      start_date: '2023-07-18',
      end_date: '2023-07-18',
      description: '',
      lat: 40.7570877,
      lon: -73.8458213,
      visitors: 28000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-4273944',
      hotel: 1,
      url: '',
      created_timestamp: '2022-11-16T01:07:15.000Z',
      last_update_timestamp: '2023-07-19T07:05:26.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-18,1'],
      days: ['2023-07-18'],
      labels: ['baseball', 'mlb', 'sport'],
    },
    {
      name: 'World Bronchiectasis and NTM Conference',
      location: 'New York Hilton Midtown',
      category: 'conference',
      importance: 2,
      start_date: '2023-07-18',
      end_date: '2023-07-20',
      description: '',
      lat: 40.7625578,
      lon: -73.97979670000001,
      visitors: 500,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-4620430',
      hotel: 1,
      url: '',
      created_timestamp: '2023-02-05T11:05:57.000Z',
      last_update_timestamp: '2023-07-08T06:07:40.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-18,1', '2023-07-19,1', '2023-07-20,1'],
      days: ['2023-07-18', '2023-07-19', '2023-07-20'],
      labels: ['conference'],
    },
    {
      name: 'Apparel Sourcing New York City',
      location: '',
      category: 'conference',
      importance: 2,
      start_date: '2023-07-18',
      end_date: '2023-07-20',
      description: '',
      lat: 40.757551,
      lon: -74.002469,
      visitors: 50000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-5016296',
      hotel: 1,
      url: '',
      created_timestamp: '2023-04-14T01:07:00.000Z',
      last_update_timestamp: '2023-07-20T14:42:55.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-18,1', '2023-07-19,1', '2023-07-20,1'],
      days: ['2023-07-18', '2023-07-19', '2023-07-20'],
      labels: ['expo'],
    },
    {
      name: 'Texworld New York City',
      location: 'Jacob K. Javits Convention Center',
      category: 'conference',
      importance: 2,
      start_date: '2023-07-18',
      end_date: '2023-07-20',
      description: '',
      lat: 40.7568555,
      lon: -74.00168640000003,
      visitors: 5400,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-5019289',
      hotel: 1,
      url: '',
      created_timestamp: '2023-04-14T07:06:03.000Z',
      last_update_timestamp: '2023-07-16T06:05:27.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-18,1', '2023-07-19,1', '2023-07-20,1'],
      days: ['2023-07-18', '2023-07-19', '2023-07-20'],
      labels: ['expo'],
    },
    {
      name: 'Première Vision New York',
      location: 'Center 415',
      category: 'conference',
      importance: 1,
      start_date: '2023-07-18',
      end_date: '2023-07-19',
      description: '',
      lat: 40.750622,
      lon: -73.982869,
      visitors: 3600,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-5266387',
      hotel: 1,
      url: '',
      created_timestamp: '2023-05-23T01:06:46.000Z',
      last_update_timestamp: '2023-07-07T06:16:54.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-18,1', '2023-07-19,1'],
      days: ['2023-07-18', '2023-07-19'],
      labels: ['clothing', 'expo', 'product'],
    },
    {
      name: 'Printsource New York',
      location: '',
      category: 'conference',
      importance: 1,
      start_date: '2023-07-18',
      end_date: '2023-07-20',
      description: '',
      lat: 40.757551,
      lon: -74.002469,
      visitors: 50000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-5275607',
      hotel: 1,
      url: '',
      created_timestamp: '2023-05-24T07:05:48.000Z',
      last_update_timestamp: '2023-07-06T06:08:51.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-18,1', '2023-07-19,1', '2023-07-20,1'],
      days: ['2023-07-18', '2023-07-19', '2023-07-20'],
      labels: ['expo'],
    },
    {
      name: 'HLPF Event: Just Transitions for All: Achieving Climate & Social Justice',
      location: '',
      category: 'conference',
      importance: 1,
      start_date: '2023-07-18',
      end_date: '2023-07-18',
      description: '',
      lat: 40.7519846,
      lon: -73.9697795,
      visitors: 200,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-5559785',
      hotel: 1,
      url: '',
      created_timestamp: '2023-07-07T17:07:51.000Z',
      last_update_timestamp: '2023-07-08T06:07:40.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-18,1'],
      days: ['2023-07-18'],
      labels: ['conference'],
    },
    {
      name: 'Quirks Event',
      location: 'Jacob K. Javits Convention Center',
      category: 'conference',
      importance: 1,
      start_date: '2023-07-19',
      end_date: '2023-07-20',
      description: '',
      lat: 40.7568555,
      lon: -74.00168640000003,
      visitors: 5000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-4142501',
      hotel: 1,
      url: '',
      created_timestamp: '2022-10-16T06:10:33.000Z',
      last_update_timestamp: '2023-07-06T06:08:48.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-19,1', '2023-07-20,1'],
      days: ['2023-07-19', '2023-07-20'],
      labels: ['expo'],
    },
    {
      name: 'Chicago White Sox vs New York Mets',
      location: 'Citi Field',
      category: 'sport',
      importance: 1,
      start_date: '2023-07-19',
      end_date: '2023-07-19',
      description: '',
      lat: 40.7570877,
      lon: -73.8458213,
      visitors: 29000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-4273943',
      hotel: 1,
      url: '',
      created_timestamp: '2022-11-16T01:07:15.000Z',
      last_update_timestamp: '2023-07-19T08:05:13.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-19,1'],
      days: ['2023-07-19'],
      labels: ['baseball', 'mlb', 'sport'],
    },
    {
      name: 'LINEAPELLE NEW YORK',
      location: 'Metropolitan Pavilion',
      category: 'conference',
      importance: 1,
      start_date: '2023-07-19',
      end_date: '2023-07-20',
      description: '',
      lat: 40.740543,
      lon: -73.995756,
      visitors: 1200,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-4718577',
      hotel: 1,
      url: '',
      created_timestamp: '2023-02-19T08:05:57.000Z',
      last_update_timestamp: '2023-07-07T06:16:41.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-19,1', '2023-07-20,1'],
      days: ['2023-07-19', '2023-07-20'],
      labels: ['expo'],
    },
    {
      name: 'In-Person Event: Rare Book School Lecture',
      location: 'Grolier Club',
      category: 'conference',
      importance: 1,
      start_date: '2023-07-19',
      end_date: '2023-07-19',
      description: '',
      lat: 40.764004,
      lon: -73.969862,
      visitors: 100,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-5243621',
      hotel: 1,
      url: '',
      created_timestamp: '2023-05-18T09:05:59.000Z',
      last_update_timestamp: '2023-07-07T06:16:37.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-19,1'],
      days: ['2023-07-19'],
      labels: ['conference', 'performing-arts'],
    },
    {
      name: 'Chicago White Sox vs New York Mets',
      location: 'Citi Field',
      category: 'sport',
      importance: 1,
      start_date: '2023-07-20',
      end_date: '2023-07-20',
      description: '',
      lat: 40.7570877,
      lon: -73.8458213,
      visitors: 30000,
      exhibitors: null,
      is_cancelled: false,
      is_private: false,
      are_exact_coordinates: true,
      id: '1-4273940',
      hotel: 1,
      url: '',
      created_timestamp: '2022-11-16T01:07:15.000Z',
      last_update_timestamp: '2023-07-20T20:05:25.000Z',
      status: '',
      is_new_event: false,
      periods: ['2023-07-20,1'],
      days: ['2023-07-20'],
      labels: ['baseball', 'mlb', 'sport'],
    },
  ],
  meta: {
    max_distance: 30,
  },
};

export const HOLIDAYS = {
  days: [
    {
      id: '2023-07-18',
      date: '2023-07-18',
      integer_date: 19556,
    },
    {
      id: '2023-07-19',
      date: '2023-07-19',
      integer_date: 19557,
    },
    {
      id: '2023-07-20',
      date: '2023-07-20',
      integer_date: 19558,
    },
  ],
  holidays: [],
};
